const config = {
  blockCheck: true,
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page002_game1/audio/0_Dusty.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page002_game1/img/audioOn.png', iconOff: 'games/page002_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 410 - 465,
        x: 0 + 154,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page002_game1/audio/3_Tom.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page002_game1/img/audioOn.png', iconOff: 'games/page002_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 300 - 350,
        x: 56 + 68,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page002_game1/audio/4_Lisa.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page002_game1/img/audioOn.png', iconOff: 'games/page002_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 260 - 265,
        x: 38 + 122,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page002_game1/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,

  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#4cb9fa',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 4 },
    { connectId: 2, connectedWith: 5 },
    { connectId: 3, connectedWith: 6 },
  ],

  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [
    { src: 'games/page002_game1/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page002_game1/audio/click.mp3', id: 'startConnect' },

    { src: 'games/page002_game1/audio/0_Dusty.mp3', id: 'dusty' },
    { src: 'games/page002_game1/audio/3_Tom.mp3', id: 'tom' },
    { src: 'games/page002_game1/audio/4_Lisa.mp3', id: 'lisa' },
  ],
  groups: [
    {
      name: 'left',
      items: [
        {
          connectId: 1,
          audioId: 'dusty',
          image: { src: 'games/page002_game1/img/dusty_g.png' },
          imageStyle: { position: 'absolute', width: '175px', height: '327px' },
          pos: {
            x: 1560,
            y: 150,
            width: 175,
            height: 327,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 87, y: 163 }],
        },
        {
          connectId: 2,
          audioId: 'tom',
          image: { src: 'games/page002_game1/img/tom_g.png' },
          imageStyle: { position: 'absolute', width: '190px', height: '277px' },
          pos: {
            x: 1300,
            y: 400,
            width: 190,
            height: 277,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 95, y: 138 }],
        },
        {
          connectId: 3,
          audioId: 'lisa',
          image: { src: 'games/page002_game1/img/lisa_g.png' },
          imageStyle: { position: 'absolute', width: '204px', height: '300px' },
          pos: {
            x: 1560,
            y: 600,
            width: 204,
            height: 300,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 102, y: 150 }],
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          audio: 'a01',
          connectId: 4,
          image: { src: 'games/page002_game1/img/1.png' },
          imageStyle: { position: 'absolute', width: '310px', height: '600px' },
          pos: {
            x: 360,
            y: 435,
            width: 310,
            height: 600,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 265, y: 300 }],
        },
        {
          audio: 'a02',
          connectId: 5,
          image: { src: 'games/page002_game1/img/2.png' },
          imageStyle: { position: 'absolute', width: '340px', height: '460px' },
          pos: {
            x: 690,
            y: 350,
            width: 340,
            height: 460,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 293, y: 230 }],
        },
        {
          audio: 'a03',
          connectId: 6,
          image: { src: 'games/page002_game1/img/2.png' },
          imageStyle: { position: 'absolute', width: '340px', height: '460px' },
          pos: {
            x: 50,
            y: 300,
            width: 340,
            height: 460,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 309, y: 230 }],
        },
      ],
    },
  ],
};
export default config;
